<template>
  <header id="header" class="logged-in" :class="{
    'theme-pickstar': clientName === 'Pickstar',
  }">
    <div class="header-bar">
      <div class="container-fluid">
        <div class="header-bar__container">
          <button type="button" class="navbar-toggle offcanvas-toggle" data-toggle="offcanvas" data-target="#js-bootstrap-offcanvas-nav" aria-label="Toggle navigation">
            <span class="navbar-toggle__line"></span>
            <span class="navbar-toggle__line"></span>
          </button>
          <component :is="logoComponent" :href="logoLink" class="client-logo" :class="{
            'client-logo--aoc': clientName === 'AOC',
          }" :style="!$vlastMode ? 'border: none' : ''">
            <img :src="logoSrc" style="max-height: 100px"/>
          </component>
          <div v-if="!$whitelabel && $vlastMode" class="header-bar__logo">
            <vlast-logo-full :fill="clientConfig.colours.brand_vlast_text" class="vlast-logo vlast-logo--full" />
          </div>
          <div class="header-bar__ui">
            <div class="margin-l-1" v-for="(ctaButton, index) in ctaButtons" :key="index">
              <router-link v-if="ctaButton && ctaButton.view" tag="button" :to="{ name: ctaButton.view }" class="btn btn-primary">
                <i v-if="ctaButton.icon" class="fa" :class="ctaButton.icon"></i>&nbsp;{{ ctaButton.label }}
              </router-link>
              <a v-else-if="ctaButton" class="btn btn-primary" :href="ctaButton.link">
                <i v-if="ctaButton.icon" class="fa" :class="ctaButton.icon"></i>&nbsp;{{ ctaButton.label }}
              </a>
            </div>
            <div @click="trackNotificationBellClick(notification_unread_count)">
              <router-link v-if="!$userIsAdmin && !$userIsReportingAdmin" tag="button" :to="{ name: 'notifications.index' }" class="navbar-notifications" :class="{
                'no-new': notification_unread_count === 0
              }">
                <i class="fa fa-bell"></i>
                {{ notification_unread_count }}
              </router-link>
            </div>
            <div class="user-link dropdown" :class="{
              'pickstar': clientName === 'Pickstar'
            }">
              <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-user-circle"></i>
                Hi, {{ $user.first_name }}

                <i class="fa fa-caret-down"></i>
              </a>
              <ul class="dropdown-menu">
                <li><router-link :to="{ name: 'profile.show' }">My profile</router-link></li>
                <li><router-link :to="{ name: 'logout' }">Logout</router-link></li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import $ from 'jquery'
import 'offcanvas-bootstrap/dist/js/bootstrap.offcanvas'
import { mapState } from 'vuex'
import { publicUrl } from 'utils'
import VlastLogoFull from '../components/icons/VlastLogoFull'
import { CommonTracker } from 'mixins/analytics'

export default {
  components: {
    VlastLogoFull
  },
  mixins: [CommonTracker],
  data () {
    return {
      offcanvas: null
    }
  },
  methods: {
    trackNotificationBellClick (count) {
      this.trackEvent(this.analytics.V2.NotificationBellClickEvent, [count])
    }
  },
  mounted () {
    if (!this.offcanvas) {
      this.offcanvas = new window.Offcanvas($('[data-toggle="offcanvas"]'))
    }
  },

  computed: {
    ...mapState('notifications', ['notification_unread_count']),
    ...mapState('clientConfig', ['client_config']),
    ctaButtons () {
      let requestingCta = 'Request ' + this.$starLabel

      if (this.$t('requesting_cta_button_label') && this.$t('requesting_cta_button_label') !== 'requesting_cta_button_label') {
        requestingCta = this.$t('requesting_cta_button_label')
      }

      const clientLink = this.$vlastMode ? { view: 'requests.create' } : { link: publicUrl('request/welcome') }

      const adminCtas = this.$campaigns
        ? [
          {
            label: requestingCta,
            icon: 'fa-plus',
            view: 'requests.create'
          },
          {
            label: 'Create Campaign',
            icon: 'fa-clone',
            view: 'campaign.create'
          }
        ]
        : [{
          label: requestingCta,
          icon: 'fa-plus',
          view: 'requests.create'
        }]

      let callToAction = {
        admin: adminCtas,
        'restricted-admin': adminCtas,
        'super-regional-admin': adminCtas,
        'regional-admin': adminCtas,
        client: [{
          label: requestingCta,
          icon: 'fa-plus',
          ...clientLink
        }],
        manager: this.$billboardModuleEnabled ? [{
          label: 'Discover',
          icon: 'fa-plus',
          view: 'billboard.index'
        }] : [{
          label: 'My Requests',
          icon: 'fa-plus',
          view: 'requests.index'
        }],
        talent: this.$billboardModuleEnabled ? [{
          label: 'Discover',
          icon: 'fa-plus',
          view: 'billboard.index'
        }] : [{
          label: 'My Requests',
          icon: 'fa-plus',
          view: 'requests.index'
        }]
      }
      return callToAction[this.$user.role]
    },
    homeUrl () {
      return process.env.PUBLIC_URL.replace('{tenant}', window.location.hostname.split('.')[0])
    },
    logoComponent () {
      return this.$vlastMode ? `div` : `a`
    },
    logoSrc () {
      return this.client_config.tenant_details.path_to_logo
    },
    logoLink () {
      return this.$vlastMode ? null : this.homeUrl
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/sass/bootstrap/variables";

  .header-bar {
    background-color: var(--brand-vlast);
    &__container {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      @media (min-width: 992px) {
        min-height: 96px;
      }
    }
    &__logo {
      flex-shrink: 0;
      @media (max-width: 991px) {
        display: none;
      }
      svg {
        width: 180px;
      }
    }
    &__ui {
      width: 100%;
      justify-content: flex-end;
      align-items: center;
      @media (max-width: 639px) {
        display: none;
      }
      @media (min-width: 640px) {
        display: flex;
      }
      .active {
        display: none;
      }
    }
  }

  .dropdown-menu {
    border: none;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    > li > a {
      font-family: $font-family-base;
      text-transform: uppercase;
      font-weight: 800;
      letter-spacing: 0.12em;
      padding: 1em 2em;
    }
  }

  .client-logo {
    width: 120px;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    color: inherit;
    @media (max-width: 991px) {
      height: 60px;
      margin: 15px 0;
      margin-left: auto;
      width: unset;
      svg {
        height: 60px;
        width: auto;
        .theme-pickstar & {
            height: initial;
            width: 120px;
        }
      }
    }
    @media (min-width: 992px) {
      padding-right: 30px;
      margin-right: 30px;
      border-right: 1px solid var(--brand-vlast-text);
      &--aoc {
        padding-right: 0;
        margin-right: 0;
        border: none;
      }
      .theme-pickstar & {
        svg {
          height: auto;
        }
      }

      svg {
        width: 100%;
      }
    }
  }

  .user-link {
    font-family: $font-headings;
    text-transform: uppercase;
    font-weight: 800;
    padding-left: 1rem;
    color: #fff;

    > a {
      color: #fff;
    }

    &.pickstar > a {
      color: var(--brand-vlast-text);
    }
  }

  .navbar-toggle {
    $b: #{&};
    padding: 0;
    height: 2rem;
    width: 2rem;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
    display: flex;
    @media (min-width: 992px) {
      display: none;
    }
    &__line {
      background: $gray-lighter;
      width: 1.5rem;
      height: 2px;
      display: block;
      top: 50%;
      left: 50%;
      position: absolute;
      transform-origin: center;
      will-change: transform;
      transition: transform .15s ease-in-out;
      &:first-child {
        transform: translate(-50%, -.3rem) rotate(0);
      }
      &:last-child {
        transform: translate(-50%, .3rem) rotate(0);
      }
      .theme-pickstar & {
        background: $gray-dark;
      }
    }

    &.is-open {
      #{$b}__line {
        &:first-child {
          transform: translate(-50%, -50%) rotate(-45deg);
        }
        &:last-child {
          transform: translate(-50%, -50%) rotate(45deg);
        }
      }
    }
  }
</style>
